import { render } from "./Operate.vue?vue&type=template&id=fcaff774&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"

import "./Operate.vue?vue&type=style&index=0&id=fcaff774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcaff774"]])

export default __exports__